import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11fa5dc8")

_pushScopeId("data-v-11fa5dc8")
const _hoisted_1 = { class: "new-join-view" }
const _hoisted_2 = { class: "funteamclues-new-game flex flex-column items-stretch" }
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = { for: "name" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "input-wrapper" }
const _hoisted_7 = { for: "nickname" }
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "estimate estimate-label my2" }
const _hoisted_10 = { class: "estimate estimate-label" }
const _hoisted_11 = { class: "estimate" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LogoSpinner = _resolveComponent("LogoSpinner")!
  const _component_LanguageSelection = _resolveComponent("LanguageSelection")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LogoSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_LanguageSelection, { class: "language-selection" }),
        _createVNode("div", _hoisted_3, [
          _createVNode("label", _hoisted_4, [
            _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.name')) + "*", 1)
          ]),
          _createVNode(_component_Input, {
            id: "name",
            type: "text",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.name.length > 20)
            ? (_openBlock(), _createBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 20 })), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('newGame.nickname')), 1),
          _createVNode(_component_Input, {
            id: "nickname",
            type: "text",
            modelValue: _ctx.nickname,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.nickname = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.nickname.length > 20)
            ? (_openBlock(), _createBlock("small", _hoisted_8, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 20 })), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Button, {
          disabled: !_ctx.name,
          onClick: _ctx.addGame
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.newGameLoading ? _ctx.$t('common.loading') : _ctx.$t('newGame.startNewGame')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode("div", _hoisted_9, "*" + _toDisplayString(_ctx.$t('funTeamClues.noTimeLimit')), 1),
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('newGame.estimatedGameTimeIs')), 1),
        _createVNode("div", _hoisted_11, [
          _createVNode("b", null, "25 " + _toDisplayString(_ctx.$t('newGame.estimatedMinutes')), 1)
        ])
      ])
    ])
  ], 64))
})